export default __webpack_public_path__ + "static/insights-bg-4e2392d74e0cdbfcbfa4a4a19f0e2ed6.png";